import { Component, OnInit, inject, signal } from '@angular/core';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { LoadingComponent } from '../../shared/components/loading/loading.component';
import { API_STATE_CLIENT } from './data-access/api-state-client.token';
import type { ApiResponse } from './data-access/api-state.service';

@Component({
  selector: 'api-state',
  standalone: true,
  templateUrl: './api-state.component.html',
  imports: [DatePipe, LoadingComponent],
})
export class ApiStateComponent implements OnInit{
  private readonly apiStateClient = inject(API_STATE_CLIENT);

  apiResponse = signal<any>(null);
  loading = signal(false);
  error = signal('');
  private subscription?: Subscription;

  ngOnInit(): void {
    this.fetchData();
  }

  fetchData(): void {
    this.loading.set(true);
    this.error.set('');
    
    this.subscription = this.apiStateClient.getStatus().subscribe({
      next: (response) => {
        this.apiResponse.set(response);
        this.loading.set(false);
      },
      error: (err) => {
        this.error.set('Failed to fetch data');
        this.loading.set(false);
        console.error('Error:', err);
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}


